import { useQuery } from '@eika-infrastruktur/react-query';
import getWispSignal from '../services/wispSignalService';
const TEN_MINUTES = 1000 * 60 * 10;
const useWispSignal = () => {
    return useQuery({
        queryKey: ['wispSignal'],
        queryFn: getWispSignal,
        staleTime: TEN_MINUTES,
    });
};
export default useWispSignal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlV2lzcFNpZ25hbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9mZXRjaEhvb2tzL3VzZVdpc3BTaWduYWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGlDQUFpQyxDQUFDO0FBRzNELE9BQU8sYUFBYSxNQUFNLCtCQUErQixDQUFDO0FBRTFELE1BQU0sV0FBVyxHQUFHLElBQUksR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDO0FBRW5DLE1BQU0sYUFBYSxHQUFHLEdBQUcsRUFBRTtJQUN2QixPQUFPLFFBQVEsQ0FBcUI7UUFDaEMsUUFBUSxFQUFFLENBQUMsWUFBWSxDQUFDO1FBQ3hCLE9BQU8sRUFBRSxhQUFhO1FBQ3RCLFNBQVMsRUFBRSxXQUFXO0tBQ3pCLENBQUMsQ0FBQztBQUNQLENBQUMsQ0FBQztBQUVGLGVBQWUsYUFBYSxDQUFDIn0=